module.exports = __webpack_public_path__ + "static/media/dragable.2d2d38b1.svg";